export const FETCH_ALLCOUNTRIESTOFILTER = 'FETCH_ALLCOUNTRIESTOFILTER';
export const FETCH_COUNTRIES = 'FETCH_COUNTRIES';
